/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Individual winner record for audit trail
 * @export
 * @interface DrawWinnerRecord
 */
export interface DrawWinnerRecord {
    /**
     * 
     * @type {string}
     * @memberof DrawWinnerRecord
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof DrawWinnerRecord
     */
    userEmail?: string;
    /**
     * For SEGMENT + GRAND_PRIZE draws — ref to the awarded PrizePool. Undefined for CHALLENGE_DRAW (which stores rewardConfigId directly — see below).
     * @type {string}
     * @memberof DrawWinnerRecord
     */
    prizePoolId?: string;
    /**
     * For CHALLENGE_DRAW draws — ref to the awarded RewardConfig (DrawPrize stores prizes inline, no PrizePool wrapper). Undefined for SEGMENT + GRAND_PRIZE.
     * @type {string}
     * @memberof DrawWinnerRecord
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {string}
     * @memberof DrawWinnerRecord
     */
    challengeMembershipId?: string;
    /**
     * 
     * @type {string}
     * @memberof DrawWinnerRecord
     */
    prizeName?: string;
    /**
     * 
     * @type {number}
     * @memberof DrawWinnerRecord
     */
    entriesHeld?: number;
    /**
     * 
     * @type {number}
     * @memberof DrawWinnerRecord
     */
    positionInShuffle?: number;
    /**
     * If rewards were distributed based on this log
     * @type {boolean}
     * @memberof DrawWinnerRecord
     */
    hasDistributedRewards?: boolean;
}

/**
 * Check if a given object implements the DrawWinnerRecord interface.
 */
export function instanceOfDrawWinnerRecord(value: object): value is DrawWinnerRecord {
    return true;
}

export function DrawWinnerRecordFromJSON(json: any): DrawWinnerRecord {
    return DrawWinnerRecordFromJSONTyped(json, false);
}

export function DrawWinnerRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawWinnerRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userEmail': json['userEmail'] == null ? undefined : json['userEmail'],
        'prizePoolId': json['prizePoolId'] == null ? undefined : json['prizePoolId'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'challengeMembershipId': json['challengeMembershipId'] == null ? undefined : json['challengeMembershipId'],
        'prizeName': json['prizeName'] == null ? undefined : json['prizeName'],
        'entriesHeld': json['entriesHeld'] == null ? undefined : json['entriesHeld'],
        'positionInShuffle': json['positionInShuffle'] == null ? undefined : json['positionInShuffle'],
        'hasDistributedRewards': json['hasDistributedRewards'] == null ? undefined : json['hasDistributedRewards'],
    };
}

export function DrawWinnerRecordToJSON(json: any): DrawWinnerRecord {
    return DrawWinnerRecordToJSONTyped(json, false);
}

export function DrawWinnerRecordToJSONTyped(value?: DrawWinnerRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userEmail': value['userEmail'],
        'prizePoolId': value['prizePoolId'],
        'rewardConfigId': value['rewardConfigId'],
        'challengeMembershipId': value['challengeMembershipId'],
        'prizeName': value['prizeName'],
        'entriesHeld': value['entriesHeld'],
        'positionInShuffle': value['positionInShuffle'],
        'hasDistributedRewards': value['hasDistributedRewards'],
    };
}

